define('glu/grid/savedViews/savedViews',['require','../../layout','hbs!./savedViews.hbs','../../flexDropdown','./components/dropdownItemView','./components/addNewView','../../util','../../locale'],function(require) {
    'use strict';

    var Layout = require('../../layout'),
        tmpl = require('hbs!./savedViews.hbs'),
        FlexDropdown = require('../../flexDropdown'),
        DropdownItemView = require('./components/dropdownItemView'),
        AddNewView = require('./components/addNewView'),
        util = require('../../util'),
        locale = require('../../locale');

    return Layout.extend({
        template: tmpl,

        collectionEvents: {
            'add': 'updateDropdownAndSetSelected',
            'reset': 'updateDropdownAndSetDefault',
            'remove': 'updateDropdown'
        },

        regions: {
            select: '.region-grid-select-saved-view'
        },

        initialize: function(options) {
            this.grid = options.grid;
        },

        initializeDropdown: function() {
            this.closeDropdown();
            this.dropdown = this.createDropdown();
        },

        onClose: function() {
            this.closeDropdown();
        },

        closeDropdown: function() {
            if (this.dropdown) {
                this.dropdown.close();
                this.dropdown = null;
            }
        },

        createDropdown: function() {
            var selectedValue = this.grid.stateModel.get('id'),
                dropdown;

            var flexDropdownOptions = {
                data: this.getDropDownData(),
                filter: false,
                multiSelect: false,
                preSelectedIds: selectedValue ? [selectedValue] : [],
                defaultSelectMessage: locale.get('selectView'),
                label: locale.get('savedViews'),
                showTooltip: false,
                showCancelIcon: false,
                clearBtn: false,
                disableMultiButton: true,
                disabled: false,
                customView: AddNewView,
                customViewOptions: {
                    grid: this.options.grid,
                    savedViewsCollection: this.collection
                },
                dropDownItemView: {
                    viewClass: DropdownItemView,
                    viewOptions: {
                        savedViewsCollection: this.collection
                    }
                }
            };

            dropdown = new FlexDropdown(flexDropdownOptions);

            this.listenTo(dropdown, 'selectionChanged:id', this.handleSelectView);

            return dropdown;
        },

        handleSelectView: function(ids) {
            var id = ids[0];

            if (!id) {
                return this.trigger('grid:use:savedView', this.collection.getDefaultModel());
            }

            // if selectedViewId is the same then we shouldn't update grid.
            if (id === this.grid.stateModel.get('id')) {
                return;
            }

            this.trigger('grid:use:savedView', this.collection.get(id));
        },

        onBeforeRender: function() {
            this.initializeDropdown();
        },

        onRender: function() {
            this.showDropdown();
        },

        showDropdown: function() {
            this.select.show(this.dropdown);
            this.enableDropdown();
        },

        enableDropdown: function() {
            if (!this.collection.isEmpty()) {
                return;
            }

            // only if we don't have previous saved views.
            this.$('.selection').removeClass('disabled');
        },

        openDropdown: function() {
            util.defer(function() {
                if (this.dropdown) {
                    this.dropdown.openDropdown();
                }
            }.bind(this));
        },

        getDropDownData: function() {
            return this.collection.map(function(item) {
                return {
                    id: item.get('id'),
                    name: item.get('name')
                };
            });
        },

        updateDropdownAndSetSelected: function(addedModel) {
            if (!this.dropdown) {
                return;
            }

            this.updateDropdown();
            this.dropdown.setSelectedIds(addedModel.get('id'));
        },

        updateDropdownAndSetDefault: function() {
            if (!this.dropdown) {
                return;
            }

            this.updateDropdown();

            var defaultModel = this.collection.getDefaultModel();
            if (defaultModel) {
                this.dropdown.setSelectedIds(defaultModel.get('id'));
            }
        },

        updateDropdown: function(model) {
            if (!this.dropdown) {
                return;
            }

            this.dropdown.setData(this.getDropDownData());
        }
    });
});

